module.exports = __webpack_public_path__ + "assets/img/odium.cec335d8.png";